"use client";

import AuthForm from "../AuthForm";

export default function SignUpPage() {
  return (
    <AuthForm
      title="Create your account"
      subtitle="Enter your email to receive a magic link."
      buttonLabel="Send magic link"
    />
  );
}
